<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Show from "./show";
import { mapGetters } from 'vuex';

export default {
  page: {
    title: "استمارة قطع الاراضي والبدل النقدي - الجريح",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Show},
  data() {
    return {
      title: "المسجلين في الاستمارة",
      items: [
        {
          text: "الرئيسيه",
          href: "/"
        },
        {
          text: "استمارة قطع الاراضي والبدل النقدي - الجريح",
          active: true,
        }
      ],
      
      canShow: false,
      loadingContent: true
    };
  },
  computed:{
    ...mapGetters('auth', ['getUser']),
  },
  created(){
    this.canShow = this.getUser.hasAnyPermission(['show_land','show_details_land']);
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">

      <div class="col-md-12">
        <div class="card">

          <div class="card-body">
            <Show v-if="canShow" />
          </div>

        </div>
      </div>
                    
    </div>
    
  </Layout>
</template>